@if(!form){
Loading form...
}
@else{
<div class="dynamic-form-holder">
  <form (ngSubmit)="onSubmit()" [formGroup]="form()" class="full-width">
    @if (editType == 'edit_services_or_pricing' || !isUpdate){
    <p>
      <mat-slide-toggle [formControl]="confirmPricesControl" labelPosition="before" style="float:right;">Salesman Controls</mat-slide-toggle>
    </p>
    @if (!aggregatedServiceSelections || aggregatedServiceSelections.length === 0) {
    <h4>Included Services:</h4>

    <mat-selection-list #servicesList [formControl]="servicesControl" name="services" [multiple]="true">
      @for (service of serviceOptions; track service) {
      <mat-list-option [value]="service.id" [selected]="selection.isSelected(service)">{{service.title}} @if (!competitorControl || !competitorControl.value) {: Standard Monthly Price: {{service.retail_price | currency}}}</mat-list-option>
      }
    </mat-selection-list>
    }

    @if(confirmPricesControl.value){
    @if(!isUpdate){
    <p>
      <mat-slide-toggle [formControl]="competitorControl" labelPosition="before" style="float:right;">Already Has Pest Control</mat-slide-toggle>
    </p>
    }
    <!-- End Already Has Pest Control -->
    <h4>Salesman Controls:</h4>

    @for(override of priceOverrides; track override.id){
    <div class="override-row">
      @if(competitorControl.value){
      <mat-form-field [ngClass]="{'half-width': competitorControl.value, 'full-width': !competitorControl.value}" appearance="outline">
        <mat-label>{{override.label | slice:0:25}}@if (override.label.length > 25){...} -Current Price</mat-label>
        <input matInput type="number" [min]="override.min_price" [formControl]="override.competitorField">
      </mat-form-field>
      }

      <mat-form-field [ngClass]="{'half-width': competitorControl.value, 'full-width': !competitorControl.value}" appearance="outline">
        <mat-label>{{override.label}}</mat-label>
        <input matInput type="number" [min]="override.min_price" [formControl]="override.field">
      </mat-form-field>
    </div>
    }
    }
    }
    <!-- END updatePricing -->

    @if (editType == 'edit_schedule' || !isUpdate){
    <h4>Billing Schedule</h4>
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Bill Cycle</mat-label>
      <mat-select [formControl]="billCycleControl">
        <mat-option value="month">Monthly</mat-option>
        <mat-option value="year">Yearly</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Bill Every - Number of {{billCycleControl.value}}(s)</mat-label>
      <input matInput type="number" min="1" [max]="maxIntervals" [formControl]="intervalCountControl">
      @if (ddbSub && ddbSub.preferred_bill_date) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="ddbSub.value=todayDayOfMonth">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>

    @if(billCycleControl.value == 'year'){
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Preferred Bill Month</mat-label>
      <input matInput type="number" min="1" max="12" [formControl]="preferredBillMonthControl">
      @if (ddbSub && ddbSub.preferred_bill_date) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="ddbSub.value=todayDayOfMonth">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>
    }

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Preferred Bill Date</mat-label>
      <input matInput type="number" min="1" max="31" [formControl]="preferredBillDateControl">
      @if (ddbSub && ddbSub.preferred_bill_date) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="ddbSub.value=todayDayOfMonth">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>
    }
    <!-- END updateSchedule -->

    @if (!isUpdate){
    <section class="customer-credits-section">
      <h4>Customer Credits</h4>
      <p>
        <mat-checkbox [formControl]="cancelationControl">The customer cancelled an existing contract to switch to Complete Pest Control.</mat-checkbox>
      </p>
      @if(cancelationControl.value == true){
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Cancellation Fee Credit</mat-label>
        <input matInput type="number" min="-250" max="300" [formControl]="cancelationAmountControl">
      </mat-form-field>
      }
      <h4>First Service Fee</h4>
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>First Service Fee</mat-label>
        <input matInput type="number" min="0" max="150" [formControl]="firstServiceFeeControl">
      </mat-form-field>
    </section>
    }

    <hr style="margin-bottom:20px" />

    <div class="form-row">
      @if (payLoad){

      <!-- TOTALS CARD -->
      <mat-card class="summary-card" appearance="outlined">
        <mat-card-header>
          <mat-card-title>SUBSCRIPTION TOTALS</mat-card-title>
          <mat-card-subtitle>
            @if (subscriptionTotals.totalPriceBeforeDiscount != subscriptionTotals.grandTotalPrice){
            <span class="retail-price">{{ subscriptionTotals.totalPriceBeforeDiscount | currency }}</span>
            }
            <span class="sale-price">{{ subscriptionTotals.grandTotalPrice | currency }}</span>
            / {{periodStr}}
          </mat-card-subtitle>
        </mat-card-header>
        @if (showSubTotals){
        <mat-card-content>
          @if (subscriptionTotals.totalBundleDiscount){
          <p><b>Total Bundle Discount: </b> {{subscriptionTotals.totalBundleDiscount | currency }}</p>
          }
          @if (subscriptionTotals.totalPrepayDiscount){
          <p><b>Total Prepay Discount: </b> {{subscriptionTotals.totalPrepayDiscount | currency }}</p>
          }
          @if (subscriptionTotals.totalSalesDiscount){
          <p><b>Total Sales Discount: </b> {{subscriptionTotals.totalSalesDiscount | currency }}</p>
          }
          @if (subscriptionTotals.grandTotalDiscount){
          <p><b>Total Discount: </b> {{subscriptionTotals.grandTotalDiscount | currency }}</p>
          }
          @if (subscriptionTotals.totalRetailDiscount && subscriptionTotals.totalRetailDiscount != subscriptionTotals.grandTotalDiscount){
          <p><b>Retail Discount: </b> {{subscriptionTotals.totalRetailDiscount | currency }}</p>
          }

          @for (s of selectedServiceObjs; track s) {
          @if (s.price_builder){
          <mat-card class="summary-card" appearance="outlined">
            <mat-card-header>
              <mat-card-title>{{s.service.title}}</mat-card-title>
              <mat-card-subtitle>
                @if (s.price_builder.totalPriceBeforeDiscount != s.price_builder.grandTotalPrice){
                <span class="retail-price">{{ s.price_builder.totalPriceBeforeDiscount | currency }}</span>
                }
                <span class="sale-price">{{ s.price_builder.grandTotalPrice | currency }}</span>
                / {{periodStr}}
              </mat-card-subtitle>
            </mat-card-header>
            @if (s.price_builder.totalBundleDiscount || s.price_builder.totalPrepayDiscount || s.price_builder.totalSalesDiscount || s.price_builder.grandTotalDiscount || s.price_builder.totalRetailDiscount){
            @if (s.show_details){
            <mat-card-content>
              @if (s.price_builder.totalBundleDiscount){
              <p><b>Service Bundle Discount: </b> {{s.price_builder.totalBundleDiscount | currency }}</p>
              }
              @if (s.price_builder.totalPrepayDiscount){
              <p><b>Service Prepay Discount: </b> {{s.price_builder.totalPrepayDiscount | currency }}</p>
              }
              @if (s.price_builder.totalSalesDiscount){
              <p><b>Service Sales Discount: </b> {{s.price_builder.totalSalesDiscount | currency }}</p>
              }
              @if (s.price_builder.grandTotalDiscount){
              <p><b>Total Service Discount: </b> {{s.price_builder.grandTotalDiscount | currency }}</p>
              }
              @if (s.price_builder.totalRetailDiscount && s.price_builder.totalRetailDiscount != s.price_builder.grandTotalDiscount){
              <p><b>Service Retail Discount: </b> {{s.price_builder.totalRetailDiscount | currency }}</p>
              }
            </mat-card-content>
            }
            <mat-card-actions>
              <button mat-button type="button" (click)="s.show_details = !s.show_details">SERVICE DISCOUNT DETAILS</button>
            </mat-card-actions>
            }
          </mat-card>
          }
          }
        </mat-card-content>
        }
        <mat-card-actions>
          <button mat-button type="button" (click)="showSubTotals = !showSubTotals">SUBSCRIPTION DETAILS</button>
        </mat-card-actions>
      </mat-card>

      <!--
      @if (!isUpdate){
      @if (payLoad.first_service_fee_amount > 0) {
      Will charge an initial service fee of {{payLoad.first_service_fee_amount | currency}} today.
      }

      We will
      @if (payLoad.first_service_fee_amount > 0) {also}
      charge {{subscriptionTotals.grandTotalPrice | currency}} every {{periodStr}}
      @if (payLoad.cancellation_credit_amount > 0) {
      after a credit of {{payLoad.cancellation_credit_amount | currency}}
      }
      }
      -->
      }
      @else {
      Select Services above
      }
    </div>

    @if (!this.hideSaveButton && !isUpdate){
    @if (customerSyncPending()) {
    <p>This customer is still being set up in Stripe. Please wait a few seconds and try again.</p>
    }
    <button mat-fab extended type="submit" [disabled]="!form().valid || customerSyncPending()">Create Subscription</button>
    }
    @if (!this.hideSaveButton && isUpdate){
    <button mat-fab extended type="submit" [disabled]="!form().valid">Update Subscription</button>
    }

  </form>
</div>
}